import { Dayjs } from 'dayjs'

import { AstraBadge, AstraTooltip, DATE_TEMPLATES, format } from '~/astra'
import { PractitionerWaitingListCallout } from '~/components'
import { useOpenDialog } from '~/components/DialogRouter/useDialogRouter'
import { usePractitionerPredictedWaitingList } from '~/hooks/usePractitionerPredictedWaitingList'
import { Practitioner } from '~/storm'

import { InformationRow } from './InformationRow'
import { WaitingListAction } from './WaitingListAction'

type Props = {
    practitioner: Practitioner
    date: Dayjs
}

export const PredictedWaitingList = ({ practitioner, date }: Props) => {
    const openPractitionerPopover = useOpenDialog('practitioner')
    const { currentUnscheduledWaitingList, waitingListEndOfMonth, isError, isLoading } = usePractitionerPredictedWaitingList(practitioner)

    const hasNoData = currentUnscheduledWaitingList === 0
    const totalEndOfMonth = waitingListEndOfMonth
    const color = totalEndOfMonth < 0 ? 'critical' : 'default'
    const badgeText = hasNoData ? '-' : `${totalEndOfMonth}`

    if (isError) {
        return <PractitionerWaitingListCallout type="error" />
    }

    return (
        <InformationRow isLoading={isLoading}>
            <WaitingListAction
                onClick={() => openPractitionerPopover({ practitioner, defaultTab: 'predictedWaitingList' })}
                title={'Predikert'}
                subtitle={format(date, DATE_TEMPLATES.monthYear)}
            />
            <AstraTooltip tooltipContent={`${waitingListEndOfMonth} pasienter på venteliste ved slutten av perioden`}>
                <AstraBadge text={badgeText} color={color} />
            </AstraTooltip>
        </InformationRow>
    )
}
